import { StyledIconWrapper } from '../../Common/JobSaveButton/style'
import SaveIcon from '../../Icons/SaveIcon'

const FakeSaveButton: React.FC = () => {
  return (
    <StyledIconWrapper>
      <SaveIcon />
    </StyledIconWrapper>
  )
}

export default FakeSaveButton
